import React from 'react'
import _ from 'lodash'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'


export default ({
                  open,
                  onCancel,
                  onConfirm,
                  children,
                  title,
                  btnConfirmDisabled = false,
                  btnCancelDisabled = false,
                  btnConfirmText = 'Confirmar',
                  btnCancelText = 'Fechar',
                  customFullWidth = false,
                }) => {
  const handleConfirm = (event) => {
    event.stopPropagation()

    if (onConfirm) onConfirm(event)
  }

  const handleCancel = (event) => {
    event.stopPropagation()

    if (onCancel) onCancel(event)
  }

  return (<Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-content"
      disableEscapeKeyDown={true}
      onClick={(e) => e.stopPropagation()}
      sx={
        customFullWidth
          ? {
              '& .MuiDialog-container': {
                '& .MuiPaper-root': {
                  width: '100%',
                  maxWidth: 1000,
                },
              },
            }
          : {}
      }
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent sx={{ fontSize: '1.55rem' }}>
        {_.isString(children) ? (<DialogContentText id="alert-dialog-content">
            {children}
          </DialogContentText>) : (children)}
      </DialogContent>
      <DialogActions>
        {onCancel && <Button
          onClick={handleCancel}
          disabled={btnCancelDisabled}
        >{btnCancelText}</Button>}
        {onConfirm && <Button
          style={{ margin: "1.2rem" }}
          onClick={handleConfirm}
          disabled={btnConfirmDisabled}
          autoFocus={true}
          variant='contained'>
          {btnConfirmText}
        </Button>}
      </DialogActions>
    </Dialog>)
}
